<template lang="pug">
button-base.button-return.font-bold(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 戻るボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonReturn extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-return
  height var(--input-height-default)
  padding 10px
  color var(--color-input-return__text)
  background-color var(--color-input-return__background)
  border 1px solid var(--color-input-return__border)
  border-radius 20px
</style>
